export default "__VITE_ASSET__DIgVn74s__"